<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 17 18"
  >
    <g>
      <path
        :fill="color"
        d="M15.54 4.347l-.619.62-2.751-2.751.62-.62a1.46 1.46 0 0 1 2.065 0l.686.685c.569.571.569 1.495 0 2.066zM2.266 12.674l2.198 2.198-3.04.842zm.55-1.103l8.529-8.53 2.75 2.752-8.529 8.53zM15.68.77a2.629 2.629 0 0 0-3.718 0L1.542 11.192a.584.584 0 0 0-.15.257l-1.37 4.948a.584.584 0 0 0 .718.719l4.948-1.371a.584.584 0 0 0 .257-.15L16.367 5.173a2.632 2.632 0 0 0 0-3.718z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#2CEBA9',
    },
    size: {
      type: Number,
      default: 12,
    },
  },
};
</script>
